import { React, useState, useEffect, useContext } from "react";
import styled, {keyframes} from 'styled-components';
import axios from "axios";
import { AppContext } from '../AppStore';
import { RiPoliceBadgeLine } from "react-icons/ri";
import Swal from "sweetalert2";

// 현재 접속한 디바이스 타입 ('P': PC, 'T': 태블릿, 'M': 모바일 등)
const deviceType = localStorage.getItem("deviceType") || 'P';
const isTablet = deviceType === 'T';

function LicenseModal ({ licenseModalClose }) {
  const appStore = useContext(AppContext);
  const [text, setText] = useState({
    company_name:'',
    company_license_yn: 'N',
    company_license_key:'',
    company_license_start_date:'',
    company_license_end_date:'',
    diff_day:'',
    diff_live_day:''
  });
  const [ready, setReady] = useState(false);

  useEffect(() => {
    if(!isTablet &&ready){
      Swal.fire({
        title: '소프트웨어 사용권 인증서',
        text: '소프트웨어 사용권 인증서를 다운로드 하시겠습니까?',
        showCancelButton: true,
        confirmButtonText: '예', 
        cancelButtonText: '아니오',
        confirmButtonColor: '#0067a3',
        cancelButtonColor: '#d33',
      }).then(result => {
        if (result.isConfirmed) {
          var filename = text.company_license_key
          axios.get('/api/p/License/pdf',
          {   
            params : { file_name: filename },
            responseType:'blob'
          },
          { withCredentials: true })
          .then(function (response) {
              
              if(response.status === 200){
                  filename = filename + ' ' + appStore.YYYY_MM_DD_HH_MI_SS();
                  const link = document.createElement('a');
                  link.href = URL.createObjectURL(response.data);
                  link.setAttribute('download', filename+'.pdf');
                  document.body.appendChild(link);
                  link.click();
              }
          })
          .catch(function (error) {
              appStore.capture();
          })
        }
      })
    }
  }, [ready]);

  useEffect(() => {
    axios.get('/api/Common/LicenseInfo')
    .then((response) => {
      if(response.data.length === 0){
        Swal.fire({
          title: '<p style="color:red">라이센스 정보 오류</p>',
          text: '라이센스 정보가 정상적이지 않습니다.',
          confirmButtonText: '확인',
          confirmButtonColor: '#7066e0',
          timer: 5000,
          timerProgressBar: true
        }).then((result) => {
          licenseModalClose();
        });
      }else{
        setText({
          company_name: response.data.company_name,
          company_license_key: response.data.company_license_key,
          company_license_yn: response.data.company_license_yn,
          company_license_start_date: response.data.company_license_start_date,
          company_license_end_date: response.data.company_license_end_date,
          diff_day: response.data.diff_day,
          diff_live_day: response.data.diff_live_day
        })
      }
    })
    .finally(() => {
      setReady(true); 
    });
  }, []);

  return (
      <BluContainer onClick={ licenseModalClose }>
        {ready && (
          <div>
          { text.company_name !== "" && text.company_license_yn === "Y"? 
            <>
            <BaseContainer style={{ width: '315px', height: '210px' }}>
              <div style={ { float: 'none' } }>
                <p style={ { textAlign: 'center', fontSize: '24px', fontWeight: 'bold', margin: '0px' } }>{ text.company_name }</p>
              </div>
              <div style={ { float: 'none' } }>
                <p style={ { textAlign: 'center', fontSize: '24px', fontWeight: 'bold', margin: '0px' } }>{ text.company_license_key }</p>
              </div>
              <div>
                <div style={ { float: 'left', width: '100px' } }>
                  <RiPoliceBadgeLine size="95" color="#3D63AE" />
                </div>
                <div style={ { float: 'right', width: '170px' } }>
                  <p style={ { textAlign: 'center', fontSize: '17px', marginTop: '10px' } }>
                    시작일자&nbsp;&nbsp;{ text.company_license_start_date }
                  </p>
                  <p style={ { textAlign: 'center', fontSize: '17px', marginTop: '10px' } }>
                    종료일자&nbsp;&nbsp;{ text.company_license_end_date }
                  </p>
                </div>
              </div>
              <div style={ { width: '95%' } }>
                <Flow style={ { fontSize: '15px', whiteSpace: 'nowrap' } }>
                  { text.diff_day }일째 사용중이며, { text.diff_live_day }일 남았습니다.
                </Flow>
              </div>
            </BaseContainer>
            </>
            :
            <>
            <BaseContainer style={{ width: '300px', height: '80px' }}>
              <div style={ { float: 'none' } }>
                <p style={ { textAlign: 'center', fontSize: '24px', fontWeight: 'bold', margin: '0px' } }>{ text.company_name }</p>
              </div>
              <div style={ { float: 'right', width: '300px' } }>
                <p style={ { textAlign: 'center', color:'red', fontSize: '18px', marginTop: '15px' } }>
                  유효한 라이센스 정보가 없습니다.
                </p>
              </div> 
            </BaseContainer>
            </>
          }
        </div>
        )}
      </BluContainer>
  );
};

export default LicenseModal;

const BluContainer = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.3);
  backdrop-filter: blur(4px);
  z-index: 1;
`;
const BaseContainer = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 15px;
  background-color: white;
  z-index: 999;
  padding: 10px 15px;
`;
const flowText = keyframes`
  from {
    transform: translateX(0%);
  }
  to {
    transform: translateX(19%);
  }
`;

const Flow = styled.div`
    animation: ${flowText} 5s linear infinite
`;